module.exports = __webpack_public_path__ + "img/qr_code.d39b5e3e.png";